import {
	Box,
	Button,
	Card,
	CardContent,
	FormControl,
	FormControlLabel,
	InputLabel,
	MenuItem,
	Radio,
	RadioGroup,
	Select,
	Typography,
	useTheme,
} from "@mui/material";
import Container from "components/Container";
import Main from "layouts/Main";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AccountContext } from "services/account";
import { updateToken, upgradeUser } from "services/api";
import language, { changeLanguage, LANG_CODE, LangCode, langLabel } from "services/lang";
import { showSnackbar } from "services/snackbarHelper";
import { ThemeType } from "types/createTheme";

const Setting = () => {
	const theme = useTheme();
	const { themeToggler } = theme;
	const { t } = useTranslation(["common"]);
	const account = React.useContext(AccountContext);
	const navigate = useNavigate();

	const [themeMode, setThemeMode] = React.useState<ThemeType>(localStorage.getItem("themeMode") as ThemeType);
	const themeOption = [
		{
			value: "light",
			label: t("light"),
		},
		{
			value: "dark",
			label: t("dark"),
		},
		{
			value: "system",
			label: t("system"),
		},
	];
	const [lang, setLang] = React.useState(language);

	const handleThemeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const newTheme: ThemeType = event.target.value as ThemeType;
		setThemeMode(newTheme);
		themeToggler(newTheme as ThemeType);
	};
	const handleUpgrade = () => {
		upgradeUser(account.value.userId).then((resp) => {
			if (resp) {
				showSnackbar(t(resp.info, { ns: "validation" }), "success");
				updateToken().then((resp) => {
					account.setAccount(resp.userdata);
					navigate("/app/setting", { replace: true });
				});
			}
		});
	};

	const handleSignOut = async () => {
		await account.clearAccount();
		window.location.href = "/app/signin";
	};

	return (
		<Main title={t("setting")}>
			<Container
				gap={2}
				display="flex"
				flexDirection={"column"}
				alignItems={"center"}>
				<Box width={1}>
					<Typography
						color="textSecondary"
						sx={{ mb: 1 }}>
						{t("deviceSetting")}
					</Typography>
					<Card>
						<CardContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
							<Box>
								<Typography variant="h6">{t("theme")}</Typography>
								<RadioGroup
									value={themeMode}
									onChange={handleThemeChange}>
									{themeOption.map((option) => {
										return (
											<FormControlLabel
												key={option.value}
												value={option.value}
												control={<Radio sx={{ py: 0.5 }} />}
												label={option.label}
											/>
										);
									})}
								</RadioGroup>
							</Box>
							<Typography variant="h6">{t("language")}</Typography>
							<FormControl fullWidth>
								<Select
									labelId="lang-select-label"
									id="lang-select"
									value={lang}
									onChange={(e) => {
										setLang(e.target.value);
										changeLanguage(e.target.value as LangCode);
									}}>
									{LANG_CODE.map((code) => {
										return (
											<MenuItem
												key={code}
												value={code}>
												{langLabel[code]}
											</MenuItem>
										);
									})}
								</Select>
							</FormControl>
						</CardContent>
					</Card>
				</Box>
				{account.checkPremission(["user"]) && (
					<Box>
						<Button
							variant="contained"
							onClick={handleUpgrade}>
							{t("upgradeToOrganization")}
						</Button>
					</Box>
				)}
				<Box>
					<Button
						variant="contained"
						color="error"
						onClick={handleSignOut}>
						{t("signOut")}
					</Button>
				</Box>
			</Container>
		</Main>
	);
};

export default Setting;
